import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';
import Iconify from '../Iconify';
import '../../css/roles/rolePageHeader.css';

const RisquePageHeader = ({ setOpenAddRisque, hasRisqueCreatePermission }) => {

    const { t } = useTranslation();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    const handleAddRisque = useCallback(() => {
        setOpenAddRisque(true);
    }, [setOpenAddRisque]);

    return (
        <Box className='role_page_header_main_container'>
            <Box className='role_page_header_title_box'>
                <Typography className='role_page_header_page_title'>{t("Risques")}</Typography>
            </Box>
            {isDesktop && hasRisqueCreatePermission &&
                <Box className='role_page_header_action_box' onClick={handleAddRisque}>
                    <Iconify className='role_page_header_add_icon' icon={"ic:baseline-plus"} />
                    <Typography className='role_page_header_action_title'>{t("addRisqueDialogTitle")}</Typography>
                </Box>
            }
            {!isDesktop &&
                <Box className='role_page_header_action_box'>
                    {hasRisqueCreatePermission && <Iconify className='role_page_header_add_icon' icon={"ic:baseline-plus"} onClick={handleAddRisque} />}
                </Box>
            }
        </Box>
    );
};

export default React.memo(RisquePageHeader);